import type { Colourist } from '../layers.ts';
import type { Store } from '../store.ts';
import { clear, el, pct, votes } from './dom.ts';

export function mountTooltip(root: HTMLElement, store: Store, colourist: () => Colourist): void {
  store.subscribe((s, changed) => {
    if (!changed.has('hovered')) return;
    const h = s.hovered;
    clear(root);
    if (!h) { root.hidden = true; return; }
    const loc = store.locationsFor().get(h.info.code);
    const sw = el('span', { class: 'swatch', 'aria-hidden': 'true' });
    sw.style.background = colourist().css(h.info.code) ?? 'transparent';
    root.append(
      el('div', { class: 'name' }, sw, el('span', { text: loc?.name ? `${loc.name} (${h.info.code})` : h.info.code })),
      el('div', { class: 'meta', text: `${h.info.cell} · ${votes(h.info.total)} votes · ${pct(h.info.total ? h.info.score / h.info.total : 0)} agree${h.info.runnerUp ? ` · runner-up ${h.info.runnerUp}` : ''}` }),
    );
    root.hidden = false;
    const x = Math.min(h.x + 14, window.innerWidth - root.offsetWidth - 12);
    const y = Math.min(h.y + 14, window.innerHeight - root.offsetHeight - 12);
    root.style.transform = `translate(${x}px, ${y}px)`;
  });
}
